import { createSelector } from 'reselect';
import { getValue, hasContentValue, parentPath } from '@truqc/content-path';
import { convertToAbsolutePath } from '../utils';
import { getContent } from './simpleSelectors';
import newPathSelector from './newPathSelector';
const getOnNullDependentPaths = (state, props) => {
  const _props$format = props.format,
    format = _props$format === void 0 ? {} : _props$format;
  const _format$onNull = format.onNull,
    onNull = _format$onNull === void 0 ? {} : _format$onNull;
  const _onNull$dependentCont = onNull.dependentContentPaths,
    dependentContentPaths = _onNull$dependentCont === void 0 ? [] : _onNull$dependentCont;
  return dependentContentPaths;
};
export default createSelector([getContent, getOnNullDependentPaths, newPathSelector], (content, contentPaths, currentPath) => contentPaths.some(path => {
  const absolutePath = convertToAbsolutePath(path, parentPath(currentPath));
  return hasContentValue(getValue(absolutePath, content));
}));